import { fetchImpediment } from '@/api/business/impediment'
import { useQuery } from '@tanstack/react-query'

export const impedimentKeys = {
    all: ['impediment'] as const,
    lists: () => [...impedimentKeys.all, 'list'] as const
}

export const useImpedimentQuery = () => {
      return useQuery({
          queryFn: fetchImpediment,
          queryKey: impedimentKeys.lists(),
      })
} 
